import React, { useEffect, useRef } from 'react';
import { SpeechService } from '../../services/speech.service';
import { useAppStore } from '../../store/appStore';

export const SpeechSynthesis: React.FC = () => {
  const { currentGesture } = useAppStore();
  const speechServiceRef = useRef<SpeechService>(new SpeechService());
  const lastGestureRef = useRef<string | null>(null);

  useEffect(() => {
    if (currentGesture && currentGesture.gesture !== lastGestureRef.current) {
      speechServiceRef.current.speak(currentGesture.gesture);
      lastGestureRef.current = currentGesture.gesture;
    }
  }, [currentGesture]);

  const handleSpeak = () => {
    if (currentGesture) {
      speechServiceRef.current.speak(currentGesture.gesture);
    }
  };

  const handleStop = () => {
    speechServiceRef.current.stop();
  };

  return (
    <div className="speech-controls">
      <h3>Speech Output</h3>
      <div className="button-group">
        <button 
          onClick={handleSpeak} 
          disabled={!currentGesture}
          className="btn btn-primary"
        >
          Speak Current
        </button>
        <button 
          onClick={handleStop}
          className="btn btn-secondary"
        >
          Stop Speaking
        </button>
      </div>
    </div>
  );
};
